import { branding } from '@/branding/config';
import { cn } from '@/lib/utils';
import type { BrandLogoProps } from './brand-logo.types';

export function BrandLogo({ showLabel = true, className, variant = 'auto' }: BrandLogoProps) {
    const isSidebar = variant === 'sidebar';
    const markClassName = 'h-8 w-8 object-contain';
    const lockupClassName = cn('h-8 w-auto object-contain', showLabel && 'h-10');

    if (showLabel) {
        if (isSidebar) {
            return (
                <div className={cn('flex items-center', className)}>
                    <img src={branding.logo.lockupLight} alt={branding.logo.alt} className={lockupClassName} />
                </div>
            );
        }

        return (
            <div className={cn('flex items-center', className)}>
                <img
                    src={branding.logo.lockupDark}
                    alt={branding.logo.alt}
                    className={cn(lockupClassName, 'dark:hidden')}
                />
                <img
                    src={branding.logo.lockupLight}
                    alt={branding.logo.alt}
                    className={cn(lockupClassName, 'hidden dark:block')}
                />
            </div>
        );
    }

    if (isSidebar) {
        return (
            <div className={className}>
                <img src={branding.logo.markLight} alt={branding.logo.alt} className={markClassName} />
            </div>
        );
    }

    return (
        <div className={className}>
            <img src={branding.logo.markDark} alt={branding.logo.alt} className={cn(markClassName, 'dark:hidden')} />
            <img
                src={branding.logo.markLight}
                alt={branding.logo.alt}
                className={cn(markClassName, 'hidden dark:block')}
            />
        </div>
    );
}
